/**
 * O que estava sendo escrito em CADA atendimento, guardado ao trocar de caso.
 *
 * Trocar de conversa limpava o campo: meia resposta digitada, a foto do RG
 * presa, o áudio gravado e a citação sumiam no clique da lista — e o pior caso
 * era o anexo, que NÃO sumia e ia parar no caso seguinte. Agora cada caso tem a
 * sua gaveta: sai-se dele com tudo guardado, volta-se e está lá.
 *
 * O TEXTO vai também para o `localStorage` (sobrevive a recarregar a página e
 * a queda de sessão). Arquivo e áudio ficam só na memória da aba: `File` não
 * cabe no `localStorage`, e é por isso que fechar a aba com algum preso
 * pergunta antes (`temAlgoPreso`).
 * ponytail: anexo só em memória; IndexedDB se recarregar com anexo virar queixa.
 */

const gavetas = new Map();
/* Login + setor + caso: o id é do banco do setor (o 12 de um não é o 12 do
   outro), e o rascunho é de quem escreveu — no computador dividido, quem entra
   depois não acha a meia resposta do colega pronta para sair com o Enter. */
let dono = "";
const chave = (caso) => `rascunho:${dono}:${caso}`;

export function usarSetor(nome, usuario) {
  const novo = `${usuario ?? ""}:${nome ?? ""}`;
  if (novo !== dono) gavetas.clear();
  dono = novo;
}

export function guardarTexto(caso, texto) {
  if (!caso) return;
  try {
    if (texto?.trim()) localStorage.setItem(chave(caso), texto);
    else localStorage.removeItem(chave(caso));
  } catch {
    /* aba privada sem armazenamento: a gaveta da memória ainda vale */
  }
  gavetas.set(caso, { ...gavetas.get(caso), texto });
}

export function lerTexto(caso) {
  if (!caso) return "";
  const naMemoria = gavetas.get(caso)?.texto;
  if (naMemoria != null) return naMemoria;
  try {
    return localStorage.getItem(chave(caso)) ?? "";
  } catch {
    return "";
  }
}

/** Guarda o resto (anexos, recado, citação, edição, destino) do caso que sai. */
export function guardarResto(caso, resto) {
  if (!caso) return;
  gavetas.set(caso, { ...gavetas.get(caso), ...resto });
}

export function acrescentarAnexos(caso, novos) {
  const g = gavetas.get(caso) ?? {};
  gavetas.set(caso, { ...g, anexosPendentes: [...(g.anexosPendentes ?? []), ...novos] });
}

/** Devolve e esvazia o resto guardado — quem pega passa a ser o estado da tela. */
export function tirarResto(caso) {
  const g = gavetas.get(caso);
  if (!g) return {};
  const { texto, ...resto } = g;
  gavetas.set(caso, { texto });
  return resto;
}

/** O envio de um caso terminou com outro aberto: a gaveta dele esvazia. */
export function esvaziar(caso) {
  gavetas.delete(caso);
  try {
    localStorage.removeItem(chave(caso));
  } catch {
    /* idem */
  }
}

/** Algum caso FORA da tela segura arquivo ou áudio que só existe nesta aba. */
export function temAlgoPreso() {
  for (const g of gavetas.values()) if (g.anexosPendentes?.length || g.recado_voz?.bloco) return true;
  return false;
}
